import React, { useState, useEffect } from 'react';
import { getUnixTime } from 'date-fns'
import { toast } from 'react-toastify';
import { useForm, useFetch } from '../../../../hooks'
import { FormHeader, FormFooter, FormBody, Form } from '../../../../modules/Form/styled';
import Buttons from '../../../../modules/Buttons';
import Button from '../../../../components/inputs/Button';
import DatePicker from '../../../../components/DatePicker';
import TextArea from '../../../../components/inputs/TextArea';
import { pathOr } from 'ramda';

const FormAddEventAbortion = ({ cowid, cowno, endpoint, onClickCancel, onClickSave }) => {
    const [date, setDate] = useState(new Date());

    const { response, doFetch } = useFetch({
        url: `/${endpoint}`,
        method: 'POST'
    })

    useEffect(() => {
        doFetch({
            data: {
                cowno
            }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const { fetching: fetchingQuickbutton, doFetch: setQuickbutton } = useFetch({
        method: 'POST'
    });

    const submit = async ({ note }) => {
        const res = await setQuickbutton({
            url: `/rpc/${pathOr('', ['data', 'step1', 'endpoint'], response)}`,
            data: {
                cowid,
                unixtime: getUnixTime(date),
                note
            }
        })
        if (res === 0) {
            const errorMessage = pathOr(null, ['data', 'step2', 'error'], response);
            errorMessage && toast.error(errorMessage);
        } else {
            onClickSave(pathOr({}, ['data', 'step2'], response));
        }
    }


    const { values, errors, handleChange, handleSubmit } = useForm({
        callback: submit
    })

    const handleChangeDate = d => {
        setDate(d);
    };

    return (
        <Form onSubmit={handleSubmit} noValidate autoComplete="off">
            <FormHeader alignLeft small>
                {pathOr('', ['data', 'step1', 'title'], response)}
            </FormHeader>
            <FormBody minHeight={false}>
                <DatePicker
                    label={pathOr('', ['data', 'step1', 'lbldate'], response)}
                    selected={date}
                    onChange={handleChangeDate}
                    dateFormat="dd.MM.yyyy"
                    maxDate={new Date()}
                />
                <TextArea
                    label={pathOr('', ['data', 'step1', 'lblnotes'], response)}
                    name='note'
                    placeholder={pathOr('', ['data', 'step1', 'placeholder'], response)}
                    onChange={handleChange}
                    value={values.note}
                    error={errors.note}
                />
            </FormBody>
            <FormFooter noMargin>
                <Buttons>
                    <Button
                        type='button'
                        onClick={onClickCancel}
                        width="50%"
                        disabled={fetchingQuickbutton}
                    >
                       {pathOr('', ['data', 'step1', 'buttons', 'cancel'], response)}
                    </Button>
                    <Button
                        type='submit'
                        width="50%"
                        green
                        disabled={fetchingQuickbutton}
                    >
                       {pathOr('', ['data', 'step1', 'buttons', 'save'], response)}
                    </Button>
                </Buttons>
            </FormFooter>
        </Form>
    )
};

export default FormAddEventAbortion;
